




























































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DeleteWaringMessage from "./deletewaringmessage.vue";
import ViewDetail from "./viewdetail.vue";
import SearchTree from "@/lib/Common/searchtree";

class PageLogsRequest extends PageRequest {
  keyword: string;
  areaId: number;
  operationType: number;
  startTime: string;
  endTime: string;
  typeId: number; //告警类型
  deviceType: number; //信息类型
  state: number; //信息状态
  waringId: string; //告警Id
}

@Component({
  components: { DeleteWaringMessage, ViewDetail },
})
export default class WaringMessage extends AbpBase {
  //复制
  del() {
    this.deleModalShow = true;
  }
  detail() {
    this.viewModalShow = true;
  }
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  deleModalShow: boolean = false;
  viewModalShow: boolean = false;
  splitnum: number = 0.15;

  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.waringmessage.list;
  }
  get loading() {
    return this.$store.state.waringmessage.loading;
  }
  isActiveChange(val: number) {
    this.$store.commit("waringmessage/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("waringmessage/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("waringmessage/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("waringmessage/setPageSize", pagesize);
    this.getpage();
  }
  getDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 18 || p.itemId == 19 || p.itemId == 20;
      });
      info.forEach((ele) => {
        this.$data.messagetype.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let devicet = detaillist.filter((p) => {
        return p.itemId == 7;
      });
      devicet.forEach((ele) => {
        this.$data.devicetype.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    if (this.pagerequest.startTime == null) {
      this.pagerequest.startTime = Moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    if (this.pagerequest.endTime == null) {
      this.pagerequest.endTime = Moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    await this.$store.dispatch({
      type: "waringmessage/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.waringmessage.pageSize;
  }
  get totalCount() {
    return this.$store.state.waringmessage.totalCount;
  }
  get currentPage() {
    return this.$store.state.waringmessage.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("WaringType"),
      key: "typeId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.typeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].name : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].name : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceType",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.deviceType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].name : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].name : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Title"),
      key: "title",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.title,
            },
          },
          params.row.title
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("WaringMessage"),
      key: "message",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.message,
            },
          },
          params.row.message
        );
      },
    },
    {
      sortable: true,
      title: this.L("State"),
      key: "state",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.state;
        let str = this.L("Unknown");
        switch (id) {
          case 1:
            str = this.L("Pending");
            break;
          case 2:
            str = this.L("Processing");
            break;
          case 3:
            str = this.L("Processed");
            break;
        }
        return h("span", str);
      },
    },
    {
      sortable: true,
      title: this.L("WaringTime"),
      key: "waringTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.waringTime == null
            ? ""
            : Moment(params.row.waringTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("HandleTime"),
      key: "handleTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.handleTime == null
            ? ""
            : Moment(params.row.handleTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("HandleMessage"),
      key: "handleMessage",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.handleMessage,
            },
          },
          params.row.handleMessage
        );
      },
    },
    {
      title: this.L("Handler"),
      key: "handler",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.handler,
            },
          },
          params.row.handler
        );
      },
    },
    {
      sortable: true,
      title: this.L("MailSend"),
      key: "mailSend",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.mailSend;
        let str = this.L("NoSend");
        switch (id) {
          case 1:
            str = this.L("SendSuccess");
            break;
          case 2:
            str = this.L("SendFaile");
            break;
          case 3:
            str = this.L("NoSend");
            break;
        }
        return h("span", str);
      },
    },
    {
      title: this.L("MailSendResult"),
      key: "mailSendResult",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.mailSendResult,
            },
          },
          params.row.mailSendResult
        );
      },
    },
    {
      sortable: true,
      title: this.L("SMSSend"),
      key: "smsSend",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.smsSend;
        let str = this.L("NoSend");
        switch (id) {
          case 1:
            str = this.L("SendSuccess");
            break;
          case 2:
            str = this.L("SendFaile");
            break;
          case 3:
            str = this.L("NoSend");
            break;
        }
        return h("span", str);
      },
    },
    {
      title: this.L("SMSSendResult"),
      key: "smsSendResult",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.smsSendResult,
            },
          },
          params.row.smsSendResult
        );
      },
    },
    {
      sortable: true,
      title: this.L("MiniAppSend"),
      key: "miniAppSend",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.miniAppSend;
        let str = this.L("NoSend");
        switch (id) {
          case 1:
            str = this.L("SendSuccess");
            break;
          case 2:
            str = this.L("SendFaile");
            break;
          case 3:
            str = this.L("NoSend");
            break;
        }
        return h("span", str);
      },
    },
    {
      title: this.L("MiniAppSendResult"),
      key: "miniAppSendResult",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.miniAppSendResult,
            },
          },
          params.row.miniAppSendResult
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("waringmessage/edit", params.row);
                  console.log(JSON.stringify(params.row))
                  this.detail();
                },
              },
            },
            this.L("ViewDetails")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "waringmessage/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    if (this.$route.params.waringId) {
      this.pagerequest.waringId = this.$route.params.waringId;
    }
    this.pagerequest.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
    this.getDetail();
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  // 时间触发
  changeTime(time) {
    this.pagerequest.startTime = Moment(time[0], "YYYY-MM-DD HH:mm:ss")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment(time[1])
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
    //console.log(this.pagerequest)
  }
  data() {
    return {
      messagetype: [], //信息类型
      devicetype: [], //设备类型
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      options2: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
